import { Component, Input } from '@angular/core';

import { IconComponent } from '@atoms/icon/icon.component';

@Component({
  selector: 'app-icon-box',
  imports: [IconComponent],
  templateUrl: './icon-box.component.html',
  styleUrl: './icon-box.component.scss',
})
export class IconBoxComponent {
  @Input() color: 'default' | 'primary' | 'secondary' | 'grey' = 'default';
  @Input() icon?: string;
  @Input() size: 'large' | 'medium' | 'small' | 'min' = 'medium';
  @Input('size-sm') sizeSm?: 'large' | 'medium' | 'small' | 'min';
  @Input() rounded?: boolean;
}
